import { useState } from 'react';
import { Field, fieldInputClass } from './fields.jsx';

/**
 * Campo de nova senha (opcional) com botão Mostrar/Ocultar.
 * @param {{ value: string, onChange: (v: string) => void }} props
 */
export function CustomerPasswordField({ value, onChange }) {
  const [show, setShow] = useState(false);

  return (
    <div className="rounded-2xl border border-amber-300/40 bg-amber-50/60 p-4 dark:border-amber-400/20 dark:bg-amber-400/5">
      <Field label="Nova senha (opcional)">
        <div className="flex gap-2">
          <div className="min-w-0 flex-1">
            <input
              type={show ? 'text' : 'password'}
              className={fieldInputClass}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder="Deixe em branco para manter a atual"
              autoComplete="new-password"
            />
          </div>
          <button
            type="button"
            onClick={() => setShow((v) => !v)}
            className="shrink-0 rounded-2xl border border-ink/10 px-3 text-xs font-medium hover:bg-ink/5 dark:border-white/10 dark:hover:bg-white/10"
          >
            {show ? 'Ocultar' : 'Mostrar'}
          </button>
        </div>
      </Field>
      <p className="mt-1.5 text-[11px] text-ink/50 dark:text-frost-muted">
        Mínimo 6 caracteres. Só altere se o cliente pediu para redefinir.
      </p>
    </div>
  );
}
